import * as React from 'react';
import { messages, keys } from './../messages';
/**
 * @hidden
 */
var onDownPreventDefault = {
    onMouseDown: function (e) { return e.preventDefault(); },
    onPointerDown: function (e) { return e.preventDefault(); }
};
/**
 * @hidden
 */
var userSelectNone = {
    userSelect: 'none'
};
/**
 * @hidden
 */
var formatString = function (input) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    args.forEach(function (value, index) {
        input = input.replace('{' + index + '}', String(value));
    });
    return input;
};
/**
 * @hidden
 */
var itemRender = function (li, itemProps) {
    return itemProps.dataItem.style ? React.cloneElement(li, li.props, (React.createElement("span", { style: itemProps.dataItem.style }, li.props.children))) : li;
};
/**
 * @hidden
 */
var units = ['px', 'em', '%'];
/**
 * @hidden
 */
var popupSettings = { animate: { openDuration: 150, closeDuration: 150 } };
/**
 * @hidden
 */
var borderStyles = [
    { textKey: keys.borderStyleNone, text: messages[keys.borderStyleNone], value: 'none' },
    { textKey: keys.borderStyleSolid, text: messages[keys.borderStyleSolid], value: 'solid' },
    { textKey: keys.borderStyleDotted, text: messages[keys.borderStyleDotted], value: 'dotted' },
    { textKey: keys.borderStyleDashed, text: messages[keys.borderStyleDashed], value: 'dashed' },
    { textKey: keys.borderStyleDouble, text: messages[keys.borderStyleDouble], value: 'double' },
    { textKey: keys.borderStyleGroove, text: messages[keys.borderStyleGroove], value: 'groove' },
    { textKey: keys.borderStyleRidge, text: messages[keys.borderStyleRidge], value: 'ridge' },
    { textKey: keys.borderStyleInset, text: messages[keys.borderStyleInset], value: 'inset' },
    { textKey: keys.borderStyleOutset, text: messages[keys.borderStyleOutset], value: 'outset' },
    { textKey: keys.borderStyleInitial, text: messages[keys.borderStyleInitial], value: 'initial' },
    { textKey: keys.borderStyleInherit, text: messages[keys.borderStyleInherit], value: 'inherit' },
    { textKey: keys.borderStyleHidden, text: messages[keys.borderStyleHidden], value: 'hidden' }
];
/**
 * @hidden
 */
function parentNode(pos, predicate) {
    for (var depth = pos.depth; depth > 0; depth--) {
        var node = pos.node(depth);
        if (predicate(node)) {
            return { node: node, depth: depth };
        }
    }
    return null;
}
export { onDownPreventDefault, formatString, itemRender, units, borderStyles, popupSettings, userSelectNone, parentNode };
